import { CategoryListItem } from '@mp/content-manager/categories/domain';

export function getCategoryListItemIdentifier({ type, version }: CategoryListItem): string {
  return type + version;
}
